import { render, staticRenderFns } from "./GeorestrictionProfileEdit.vue?vue&type=template&id=1e66b57c&scoped=true"
import script from "./GeorestrictionProfileEdit.vue?vue&type=script&lang=js"
export * from "./GeorestrictionProfileEdit.vue?vue&type=script&lang=js"
import style0 from "./GeorestrictionProfileEdit.vue?vue&type=style&index=0&id=1e66b57c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e66b57c",
  null
  
)

export default component.exports